import { ThemeDefinition } from "./types";

export const defaultTheme = "onviv";
// export const defaultTheme = "cen";
// export const defaultTheme = "insight";

export const Themes: Record<string, ThemeDefinition> = {
  insight: {
    name: "NoeticInsight",
    colors: {
      primary: "#754199",
      secondary: "#8C377D",
      tertiary: "#664D87",

      // Pill Color/Highlight on Time Picker
      accent1: "#EBDAF7",
      accent2: "#F&DAF2",
      accent3: "#EBDAF7"
    },
    text: {
      name: "NoeticInsight",
      company: "NoeticInsight, LLC",
      url: "https://www.noeticinsight.com",
      domain: "www.noeticinsight.com",
      careNavigator: "carenavigator@noeticinsight.com"
    },
    logo: "/assets/themes/Noetic/new-ni-onviv-logo.png",
    favicon: "/assets/themes/Noetic/ni-favicon.png",

    accent: "/assets/themes/Noetic/Neuron_bg.png",
    accentFactor: 1.5,

    // match: /localhost$/
    match: /noeticinsight\.com$/
  },
  onviv: {
    name: "Onviv",
    colors: {
      primary: "#754199",
      secondary: "#8C377D",
      tertiary: "#664D87",

      // Pill Color/Highlight on Time Picker
      accent1: "#EBDAF7",
      accent2: "#F&DAF2",
      accent3: "#EBDAF7"
    },
    text: {
      name: "Onviv",
      company: "Onviv, Inc.",
      url: "https://www.onviv.com",
      domain: "www.onviv.com",
      careNavigator: "carenavigator@onviv.com"
    },
    logo: "/assets/themes/Onviv/new-onviv-logo.png",
    favicon: "/assets/themes/Onviv/onviv-favicon.png",

    accent: "/assets/themes/Onviv/onviv_bg.png",
    accentFactor: 1.5,

    match: /onviv\.com$/
  }
};
